<template>
  <div id="nav-mobile" class="nav-mobile">
    <div class="nav-mobile__top">
      <div class="row position-relative">
        <div
          :class="{ 'col-auto nav-mobile__top-left mb-4': title, 'col-4 nav-mobile__top-left': !title }"
        >
          <router-link v-if="profile && user" :to="{ name: 'user' }">
            <i class="ddemo-icon icon-n-profile"></i>
          </router-link>
          <button
            v-else-if="modal"
            type="button"
            class="button button__icon button__icon--lightgrey"
            data-dismiss="modal"
          >
            <i class="demo-icon icon-back"></i>
          </button>
          <button
            v-else
            class="button button__icon button__icon--lightgrey"
            @click="goBack"
          >
            <i class="demo-icon icon-back"></i>
          </button>
          <div v-if="title" class="nav-mobile__title d-inline-block">
            {{ title }}
          </div>
        </div>
        <div v-if="!title" class="col-4 nav-mobile__top-center">
          <router-link :to="{ name: 'members' }" class="unset">
            <i @click="clearMembersStore" class="demo-icon icon-logo-black"></i>
          </router-link>
        </div>

        <div class="col-4 nav-mobile__top-right">
          <router-link
            v-if="showCoins && user"
            :to="{ name: 'payment', params: { unit: 'credits' }}"
            class="nav-mobile__coins-button"
            :class="{'nav-mobile__coins-button--membersearch': hasAlienElement}"
          >
            <p class="card-points__points">
              {{ user.coins + user.free_coins }}
              <i class="demo-icon icon-n-lova-coins"></i>
            </p>
          </router-link>

          <i v-if="search" class="demo-icon icon-research_bold"></i>
        </div>
      </div>
      <hr v-if="title">
    </div>
    <BottomMobileMenu v-if="bottom"></BottomMobileMenu>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BottomMobileMenu from './BottomMobileMenu';
import MobileMenuGoBack from '../../../front/views/elements/MobileMenuGoBack';
import ClearMembersStore from '../../../front/views/elements/ClearMembersStore';

export default {
  name: 'MobileMenu',
  components: { BottomMobileMenu },
  mixins: [MobileMenuGoBack, ClearMembersStore],
  props: {
    title: {
      type: String,
      default: null,
    },
    profile: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
    modal: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    returnUrl: {
      type: String,
      default: null,
    },
    showCoins: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    hasAlienElement: function () {
      if (window.location.hash === '#Neighbours') {
        return true;
      }

      if (this.$route.name === 'members' && window.location.hash === '') {
        return true;
      }

      if (this.$route.name === 'user') {
        return true;
      }

      return false;
    },
  },
  methods: {},
  mounted() {
  }
};
</script>
